import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { QuerySectionStatesTrackingQuery, QuerySectionStatesTrackingQueryPayload } from '../api'
import { SectionSuspendDataStateStore } from './section-suspend-data-state-store';
import { QueryHandler } from '@/app/tracking/common';

const debug = Debug('query-section-states-query-handler')

@injectable()
export class QuerySectionStatesQueryHandler implements QueryHandler<QuerySectionStatesTrackingQuery> {

  constructor (
    @inject(SectionSuspendDataStateStore)
    private sectionStateStore: SectionSuspendDataStateStore,
  ) {}
  
  public async execute(query: QuerySectionStatesTrackingQueryPayload) {

    debug('execute', query)

    const sections = await this.sectionStateStore.query('all')

    debug('sections', sections)

    return {
      sections: sections
    }
  }
}
